import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TenantConfigurationService {
    constructor(private readonly http: HttpClient) { }

    getTenantSessionTimeout(clientId: string): Observable<number | null> {
        return this.http.get<number | null>(`/api/tenant/config/sessiontimeout/${clientId}`);
    }
}